"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIStepperInput = _interopRequireDefault(require("UIComponents/input/UIStepperInput"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _Subtext = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/text/Subtext"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _MerchandiseIdBillingNameKeyMap = _interopRequireDefault(require("self-service-api/constants/MerchandiseIdBillingNameKeyMap"));

var _PriceDisplay = _interopRequireDefault(require("./pricing/PriceDisplay"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

var StyledTile = (0, _styledComponents.default)(_UITile.default).withConfig({
  displayName: "SeatsPicker__StyledTile",
  componentId: "sc-1l9owbe-0"
})(["margin-top:24px;font-size:12px;text-align:center;padding:8px;"]);

var SmallHeader = _styledComponents.default.span.withConfig({
  displayName: "SeatsPicker__SmallHeader",
  componentId: "sc-1l9owbe-1"
})(["font-size:14px;font-weight:600;"]);

function SeatsPicker(_ref) {
  var additionalUnitQuantity = _ref.additionalUnitQuantity,
      merchandiseId = _ref.merchandiseId,
      onChange = _ref.onChange,
      term = _ref.term,
      hideFreeUsersDisclaimer = _ref.hideFreeUsersDisclaimer,
      useHubSpecificTitle = _ref.useHubSpecificTitle,
      _ref$isGrowthSuite = _ref.isGrowthSuite,
      isGrowthSuite = _ref$isGrowthSuite === void 0 ? false : _ref$isGrowthSuite,
      _ref$isCovidPromo = _ref.isCovidPromo,
      isCovidPromo = _ref$isCovidPromo === void 0 ? false : _ref$isCovidPromo;
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[merchandiseId];
  var minPurchasableSeats = merchandiseMap[merchandiseId].includedAdditionalUnits;
  var getAdditionalSeatMonthlyCost = (0, _reactRedux.useSelector)(_PricingSelectors.getAdditionalSeatMonthlyCostSelector);
  var additionalUnitPrice = getAdditionalSeatMonthlyCost(merchandiseId, term, isGrowthSuite, isCovidPromo);

  var roundValue = function roundValue(_ref2) {
    var value = _ref2.target.value;
    var roundedValue = Math.round(value);
    var nextAdditionalUnitQuantity = roundedValue < minPurchasableSeats ? minPurchasableSeats : roundedValue;
    nextAdditionalUnitQuantity = nextAdditionalUnitQuantity - minPurchasableSeats;
    onChange(nextAdditionalUnitQuantity);
  };

  var titleId = "seats-picker-title-" + merchandiseId;
  return _react.default.createElement("div", null, useHubSpecificTitle ? _HubMap.default[_Hubs.default.HUB_SALES].merchandise.includes(merchandiseId) ? _react.default.createElement(SmallHeader, {
    id: titleId
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.seats.hubSpecificTitles.sales"
  })) : _react.default.createElement(SmallHeader, {
    id: titleId
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.seats.hubSpecificTitles.service"
  })) : _react.default.createElement(_H.default, {
    id: titleId
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.seats.title"
  })), _react.default.createElement(_UIFlex.default, {
    direction: "row",
    justify: "between",
    align: "center"
  }, _react.default.createElement(_Small.default, {
    style: {
      paddingRight: '15px'
    }
  }, _react.default.createElement(_Subtext.default, null, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.calculator.seats.subtext." + billingNameKey + "_jsx",
    elements: {
      PriceDisplay: _PriceDisplay.default
    },
    options: {
      currencyCode: currencyCode,
      price: additionalUnitPrice
    }
  }))), _react.default.createElement(_UIFormControl.default, {
    "aria-labelledby": titleId
  }, _react.default.createElement(_UIStepperInput.default, {
    style: {
      width: '100px'
    },
    disabled: !merchandiseId,
    value: additionalUnitQuantity + minPurchasableSeats,
    min: minPurchasableSeats,
    onChange: roundValue,
    "data-selenium-id": "seats-picker-input"
  }))), !hideFreeUsersDisclaimer && _react.default.createElement(StyledTile, null, _react.default.createElement("b", null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.seats.unlimitedFreeUsers.title"
  })), _react.default.createElement(_Subtext.default, null, _react.default.createElement(_FormattedMessage.default, {
    className: "m-left-1",
    message: "pricingPage.calculator.seats.unlimitedFreeUsers.text"
  }))));
}

var _default = SeatsPicker;
exports.default = _default;
module.exports = exports.default;